export default "__VITE_ASSET__DKQkjYnU__"